/**
 * 设备检测和路由跳转工具类
 */

/**
 * 检测是否为移动设备
 * @returns {boolean} 是否为移动设备
 */
export function isMobileDevice() {
  // 只使用窗口大小检测
  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight
  return windowWidth <= 480 || windowHeight <= 480
}

/**
 * 检测是否为平板设备
 * @returns {boolean} 是否为平板设备
 */
export function isTabletDevice() {
  // 只使用窗口大小检测
  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight
  return (windowWidth > 480 && windowWidth <= 768) || 
         (windowHeight > 480 && windowHeight <= 768)
}

/**
 * 获取设备类型
 * @returns {string} 设备类型：'mobile', 'tablet', 'desktop'
 */
export function getDeviceType() {
  const isMobile = isMobileDevice()
  const isTablet = isTabletDevice()
  
  if (isMobile) {
    return 'mobile'
  } else if (isTablet) {
    return 'tablet'
  } else {
    return 'desktop'
  }
}

/**
 * 根据设备类型获取对应的登录页面路由
 * @returns {string} 登录页面路由名称
 */
export function getLoginRouteName() {
  const deviceType = getDeviceType()
  
  switch (deviceType) {
    case 'mobile':
      return 'MobileLogin'
    case 'tablet':
      // 平板设备也使用移动端登录页面
      return 'MobileLogin'
    case 'desktop':
    default:
      return 'login'
  }
}

/**
 * 根据设备类型获取对应的首页路由
 * @returns {string} 首页路由名称
 */
export function getHomeRouteName() {
  // 所有设备都使用PC端的dashboard
  return 'dashboard'
}

/**
 * 智能路由跳转
 * 根据设备类型和当前路由智能跳转到合适的页面
 * @param {Object} router - Vue Router实例
 * @param {string} targetRoute - 目标路由名称
 * @param {Object} options - 跳转选项
 */
export function smartRoutePush(router, targetRoute, options = {}) {
  const deviceType = getDeviceType()
  const currentRoute = router.currentRoute
  
  // 如果是移动设备，且目标路由是PC端页面，则跳转到移动端对应页面
  if (deviceType === 'mobile' || deviceType === 'tablet') {
    // 移动端路由映射
    const mobileRouteMap = {
      'login': 'MobileLogin',
      'MobileForm': 'MobileForm'
    }
    
    const mobileRoute = mobileRouteMap[targetRoute] || targetRoute
    
    // 如果目标路由存在移动端版本，使用移动端版本
    if (mobileRoute !== targetRoute) {
      router.push({ name: mobileRoute, ...options })
      return
    }
  }
  
  // 默认跳转（包括dashboard，所有设备都跳转到PC端dashboard）
  router.push({ name: targetRoute, ...options })
}

/**
 * 检查是否需要重定向到移动端页面
 * @param {Object} router - Vue Router实例
 * @param {boolean} isLoggedIn - 用户是否已登录
 * @returns {boolean} 是否需要重定向
 */
export function shouldRedirectToMobile(router, isLoggedIn = false) {
  // 如果用户已登录，不需要重定向
  if (isLoggedIn) {
    return false
  }
  
  const deviceType = getDeviceType()
  const currentRoute = router.currentRoute
  
  // 如果是移动设备，且当前在PC端登录页面，需要重定向
  if ((deviceType === 'mobile' || deviceType === 'tablet') && currentRoute.name === 'login') {
    return true
  }
  
  return false
}

/**
 * 检查是否需要重定向到PC端页面
 * @param {Object} router - Vue Router实例
 * @param {boolean} isLoggedIn - 用户是否已登录
 * @returns {boolean} 是否需要重定向
 */
export function shouldRedirectToPC(router, isLoggedIn = false) {
  // 如果用户已登录，不需要重定向
  if (isLoggedIn) {
    return false
  }
  
  const deviceType = getDeviceType()
  const currentRoute = router.currentRoute
  
  // 如果是桌面设备，且当前在移动端登录页面，需要重定向
  if (deviceType === 'desktop' && currentRoute.name === 'MobileLogin') {
    return true
  }
  
  return false
}
